import theme from 'theme'

export const defaultStyles = {
  indicatorSeparator: styles => ({
    display: 'none',
  }),
  dropdownIndicator: (styles, { selectProps: { menuIsOpen, isDisabled } }) => ({
    ...styles,
    color: '#aaa',
    transform: menuIsOpen ? 'rotate(180deg)' : null,
    display: isDisabled ? 'none' : 'flex',
    '&:hover': {
      color: '#aaa',
      cursor: 'pointer',
    },
  }),
  clearIndicator: styles => ({
    ...styles,
    color: '#aaa',
    '&:hover': {
      color: '#aaa',
      cursor: 'pointer',
    },
  }),
  menu: (styles, state) => {
    const { menuPlacement } = state
    const base = {
      ...styles,
      borderRadius: 4,
      border: `1px solid ${theme.activeInputBorder}`,
      boxShadow: 'none',
      zIndex: 5,
    }

    if (menuPlacement === 'bottom') {
      return {
        ...base,
        borderTopLeftRadius: '0px',
        borderTopRightRadius: '0px',
        borderTop: 'none',
        marginTop: '-4px',
      }
    } else if (menuPlacement === 'top') {
      return {
        ...base,
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        borderBottom: 'none',
        marginBottom: '-4px',
      }
    }
  },
  menuList: styles => ({
    ...styles,
    backgroundColor: 'transparent',
    paddingTop: 0,
    paddingBottom: 0,
  }),
  placeholder: (base, { isDisabled }) => ({
    ...base,
    whiteSpace: 'nowrap',
    color: isDisabled ? theme.palette.text.disabled : base.color,
  }),
  option: (styles, { isSelected, isFocused }) => {
    return {
      ...styles,
      color: isSelected ? theme.palette.primary.main : theme.palette.text.primary,
      backgroundColor: isFocused ? '#f5fafd' : 'transparent',
      cursor: 'pointer',
      '&:hover': {
        backgroundColor: '#f5fafd',
      },
      borderBottomLeftRadius: 4,
      borderBottomRightRadius: 4,
    }
  },
  control: (base, state) => {
    const {
      isFocused,
      isMulti,
      selectProps: { menuIsOpen },
      isDisabled,
    } = state

    return {
      ...base,
      height: isMulti ? 'auto' : '45px',
      minHeight: '45px',
      background: isDisabled ? theme.backgroundColorDisabled : theme.backgroundColor,
      borderColor: menuIsOpen || isFocused ? theme.activeInputBorder : theme.borderColor,
      // borderBottomColor: menuIsOpen ? 'transparent' : null,
      boxShadow: 'none',
      outline: 'none',
      '&:hover': {
        ...base['&:hover'],
        borderColor: menuIsOpen ? `solid 1px ${theme.activeInputBorder}` : theme.borderColor,
      },
      '&::placeholder': {
        color: 'inherit',
      },
    }
  },
  singleValue: (base, state) => {
    const { isDisabled } = state
    return {
      ...base,
      color: isDisabled ? theme.palette.text.disabled : theme.palette.text.primary,
    }
  },
  multiValue: (base) => ({
    ...base,
    backgroundColor: theme.palette.background.chip,
    border: 'none',
    borderRadius: 16,
  }),
  multiValueLabel: (base) => ({
    ...base,
    color: theme.text,
    paddingLeft: 10,
    paddingTop: 3,
    paddingBottom: 3,
  }),
  multiValueRemove: (base, { isDisabled }) => ({
    ...base,
    color: theme.textSecondary,
    paddingLeft: 0,
    borderRadius: '0 16px 16px 0',
    paddingRight: 5,
    display: isDisabled ? 'none' : 'flex',
    '&:hover': {
      backgroundColor: 'transparent',
      color: theme.red,
      cursor: 'pointer',
    },
  }),
  container: (base) => ({
    ...base,
    backgroundColor: 'transparent!important',
    flexGrow: 1,
  }),
}

export const inlineStyles = {
  ...defaultStyles,
  valueContainer: styles => ({
    ...styles,
    padding: '0px',
  }),
  control: base => {
    return {
      ...base,
      height: '45px',
      background: '#ffffff',
      border: 'none',
      borderBottom: `1px solid ${theme.borderColor}`,
      boxShadow: 'none',
      outline: 'none',
      '&::placeholder': {
        color: 'inherit',
      },
    }
  },
}
